import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getCustomers = async (params) => {
	const { data } = await axios.get(`${API}/admin/customers`, {
		params,
	});
	return data;
};

export const getCustomer = async (params) => {
	const { data } = await axios.get(`${API}/admin/customers/detail`, {
		params,
	});
	return data;
};

export const saveCustomer = async (params) => {
	const { data } = await axios.post(`${API}/admin/customers/save`, params);
	return data;
};

export const deleteCustomer = async (params) => {
	const { data } = await axios.post(`${API}/admin/customers/delete`, params);
	return data;
};

export const statusCustomer = async (params) => {
	const { data } = await axios.post(`${API}/admin/customers/status`, params);
	return data;
};

export const syncCustomerOrders = async (params) => {
	const { data } = await axios.post(`${API}/client/sync_data_legacy`, params);
	return data;
};
